import { useMutation, useQuery, useQueryClient } from "react-query";
import { planBTAPI } from "../../services/planAPI";
import { AxiosError } from "axios";
import { CallbackFunction } from "./usePlanBTCore";
import { PolePatch } from "../../types/planBT.types";
import { useEffect } from "react";

export interface PoleCoreConfig {
  planBTId: string;
  setHeaderAuthToFutureResquest?: () => void;
}

export default function usePoleCore({ planBTId }: PoleCoreConfig) {
  const queryClient = useQueryClient();
  const getAllPole = useQuery({
    queryKey: ["pole", planBTId],
    queryFn: () => planBTAPI.GetAllPolesFromPlanBT(planBTId),
  });

  const createPoleToPlanBT = useMutation({
    mutationFn: ({
      newPole,
      callbackFunc,
    }: {
      newPole: PolePatch;
      callbackFunc?: CallbackFunction;
    }) =>
      planBTAPI
        .addPoleToPlanBT(planBTId, newPole)
        .then((result) => {
          getAllPole.refetch();
          callbackFunc && callbackFunc({ result });
        })
        .catch((error: AxiosError) => {
          callbackFunc && callbackFunc({ error });
          return Promise.reject(error);
        }),
    onSuccess: () => {
      getAllPole.refetch();
      queryClient.invalidateQueries(["pole", planBTId]);
    },
    onSettled: () => {
      getAllPole.refetch();
      queryClient.invalidateQueries(["pole", planBTId]);
    },
  });

  const detelePoleToPlanBT = useMutation({
    mutationFn: ({
      idPole,
      callbackFunc,
    }: {
      idPole: string;
      callbackFunc?: CallbackFunction;
    }) =>
      planBTAPI
        .deletePoleFromPlanBT(planBTId, idPole)
        .then((result) => {
          getAllPole.refetch();
          callbackFunc && callbackFunc({ result });
        })
        .catch((error: AxiosError) => {
          callbackFunc && callbackFunc({ error });
          return Promise.reject(error);
        }),
    onSuccess: () => {
      getAllPole.refetch();
      queryClient.invalidateQueries(["pole", planBTId]);
    },
    onSettled: () => {
      getAllPole.refetch();
      queryClient.invalidateQueries(["pole", planBTId]);
    },
  });

  useEffect(() => {
    queryClient.invalidateQueries(["pole", planBTId]);
  }, [createPoleToPlanBT.isSuccess]); // eslint-disable-line



  return {
    getAllPole: {
      ...getAllPole,
      error: getAllPole.error as AxiosError,
    },
    createPoleToPlanBT: {
      ...createPoleToPlanBT,
      error: createPoleToPlanBT.error as AxiosError,
    },
    detelePoleToPlanBT: {
      ...detelePoleToPlanBT,
      error: detelePoleToPlanBT.error as AxiosError,
    },

  };
}
